function pushToDataLayer(eventName, additionalData = {}) {
  const eventData = {
    event: eventName,
    ...additionalData,
  };
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(eventData);
}
document.addEventListener("DOMContentLoaded", function () {
  document.body.addEventListener("click", function (event) {
    const callButton = event.target.closest(".call-button_header");
    const ContactPagecallButton = event.target.closest(".contact_details-6");
    const ContactPageChatSupport = event.target.closest('.contact_details-7')
    const chatContainer =
      event.target.closest("#mobile-chat-container") ||
      event.target.closest("#new_live_chat") ||
      event.target.closest("#cart-chat-btn") ||
      event.target.closest(".info-contact img");
    const wishlistIcon = event.target.closest(".wishlist-non-active.loggedIn");
    const writeReviewButton = event.target.closest("#leaveReviewBtn");
    const submitReviewButton = event.target.closest("button.review-btn");
    const menuItem = event.target.closest(
      "summary.header__menu-item, a.header__menu-item"
    );
    const menuDrawer = event.target.closest(".menu-drawer__menu");
  
    const newsletterButton = event.target.closest(
      ".button-newsletter button#Subscribe"
    );
    if (callButton) {
      const eventName = "Top Header - Customer Care Number";
      const eventData = {
        content_group: pageName,
      };
      pushToDataLayer(eventName, eventData);
      Shopify.analytics.publish(eventName, eventData);
    }

    if (ContactPagecallButton) {
      const eventName = "Contact Page - Customer Care Number";
      const eventData = {
        content_group: pageName,
      };
      pushToDataLayer(eventName, eventData);
      Shopify.analytics.publish(eventName, eventData);
    }

    if (ContactPageChatSupport) {
      const eventName = "Contact Page - Customer Chat Support";
      const eventData = {
        content_group: pageName,
      };
      pushToDataLayer(eventName, eventData);
      Shopify.analytics.publish(eventName, eventData);
    }

      let name = document?.querySelector('.newsletter-form__field-wrapper [name="contact[first_name]"]').value;
      let email = document?.querySelector('.newsletter-form__field-wrapper [name="contact[email]"]').value;
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (newsletterButton && name !== "" && email !== "" && emailPattern.test(email)) {
      const eventName = "newsletter_click";
      const eventData = {
        content_group: pageName,
        section_name: "footer newsletter",
        newsletter_click_text: "Join Our Community",
      };

      pushToDataLayer(eventName, eventData);
      Shopify.analytics.publish(eventName, eventData);
    }

    if (chatContainer) {
      const eventName = "Top Header - Customer Care Chat";
      const eventData = {
        content_group: pageName,
      };
      pushToDataLayer(eventName, eventData);
      Shopify.analytics.publish(eventName, eventData);
    }

    if (wishlistIcon) {
      const sku = wishlistIcon.getAttribute("data-sku");
      const prodName = wishlistIcon.getAttribute("data-prod_name");
      const currency = wishlistIcon.getAttribute("data-currecny_name");
      const brand = wishlistIcon.getAttribute("data-brand");
      let category2 = "";
      let category3 = "";
      const categorymain = wishlistIcon.getAttribute("data-item_category2");
      if (categorymain) {
        category2 = wishlistIcon.getAttribute("data-item_category2");
        category3 = wishlistIcon.getAttribute("data-item_category3");
      } else {
        category2 = wishlistIcon.getAttribute("data-item_category3");
        category3 = "";
      }
      const price = wishlistIcon.getAttribute("data-price");
      const masterId = wishlistIcon.getAttribute("data-master_id");
      const eventName = "add_to_wishlist";
      const eventData = {
        ecommerce: {
          items: [
            {
              item_id: sku,
              item_name: prodName,
              item_category1: brand,
              item_category2: category2,
              item_category3: category3,
              price: price? price : 0,
              currency: currency,
              prod_master_id: masterId,
              quantity: 1,
            },
          ],
        },
      };
      pushToDataLayer(eventName, eventData);
      Shopify.analytics.publish(eventName, eventData);
    }

      if (writeReviewButton) {
      const sectionName = "Write a Review";
      const eventName = "Review";
      const eventData = {
        section_name: sectionName,
        content_group: pageName,
      };
      pushToDataLayer(eventName, eventData);
      Shopify.analytics.publish(eventName, eventData);
    }
    const firstName = document?.querySelector("#review-form-popup #firstName")?.value.trim();
    const lastName = document?.querySelector("#review-form-popup #lastName")?.value.trim();
    const reviewEmail = document?.querySelector("#review-form-popup #ContactForm-email")?.value.trim();
    const feedback = document?.querySelector("#review-form-popup #reviewMessage")?.value.trim();
    if (submitReviewButton && firstName !== "" && lastName !== "" && reviewEmail !== "" && emailPattern.test(reviewEmail) && feedback !== "") {
      const sectionName = "Submit Review";
      const eventName = "Review";
      const eventData = {
        section_name: sectionName,
        content_group: pageName,
      };
      pushToDataLayer(eventName, eventData);
      Shopify.analytics.publish(eventName, eventData);
    }

    
    if (menuItem) {
      let clickText = "";
      let clickUrl = "";

      if (menuItem.tagName === "SUMMARY") {
        const anchor = menuItem.querySelector("a");
        if (anchor) {
          const titleMegaMenu = anchor.querySelector(".title-mega-menu");
          clickText = titleMegaMenu
            ? titleMegaMenu.textContent.trim()
            : anchor.textContent.trim();
          clickUrl = anchor.href;
        }
      } else if (menuItem.tagName === "A") {
        const titleMegaMenu = menuItem.querySelector(".title-mega-menu");
        clickText = titleMegaMenu
          ? titleMegaMenu.textContent.trim()
          : menuItem.textContent.trim();
        clickUrl = menuItem.href;
      }

      const eventName = "top_menu_header_click";
      const eventData = {
        event: eventName,
        content_group: pageName, // Fallback for content group
        top_menu_header_click_text: clickText,
        top_menu_header_click_url: clickUrl,
      };

       pushToDataLayer(eventName, eventData);

      if (typeof Shopify !== "undefined" && Shopify.analytics) {
        Shopify.analytics.publish(eventName, eventData);
      }
    }

   
    if (menuDrawer) {
      const clickedItem = event.target;

      if (
        clickedItem &&
        (clickedItem.tagName.toLowerCase() === "summary" ||
          (clickedItem.classList.contains("menu-drawer__menu-item") &&
            clickedItem.classList.contains("link--text")))
      ) {
        event.preventDefault();
        let menuText = "";
        let menuUrl = "";

        if (clickedItem.tagName.toLowerCase() === "summary") {
          const link = clickedItem.querySelector("a");
          if (link) {
            menuText = link.textContent.trim();
            menuUrl = link.href;
          }
        } else if (
          clickedItem.classList.contains("menu-drawer__menu-item") &&
          clickedItem.classList.contains("link--text")
        ) {
          menuText = clickedItem.textContent.trim();
          menuUrl = clickedItem.href;
        }
         if(menuDrawer) {
           const eventName = "top_menu_header_click";
          const eventData = {
             content_group: pageName, // Content group for tracking context
              mobile_menu_item_click_text: menuText,
              mobile_menu_item_click_url: menuUrl,
          };
           pushToDataLayer(eventName, eventData);
            Shopify.analytics.publish(eventName, eventData);
         }
          
        window.location.href = menuUrl;
      }
    }
  });

  // ------------------------------ Home Page Banners Click ---------------------------------
  document.querySelectorAll(".owl-item a").forEach((link) => {
    link.addEventListener("click", (event) => {
      const img = link.querySelector("img");

      if (img) {
        const src = img.src;

        const bannerNameMatch = src.match(/\/([^/?]+)\.webp/);
        const bannerName = bannerNameMatch ? bannerNameMatch[1] : "Unknown";

        const eventName = "HomePage Banners";
        const bannerURL = link.href || "Unknown URL";

        const eventData = {
          HomePage_BannerName: bannerName,
          HomePage_BannerURL: bannerURL,
        };

        pushToDataLayer(eventName, eventData);
        Shopify.analytics.publish(eventName, eventData);
      }
    });
  });
});
